"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.greeceTranslations = void 0;
var _types = require("../../../types");
const greeceTranslations = exports.greeceTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Λυπούμαστε!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Πίσω',
  [_types.ErrorPageTranslationKey.text]: 'Η σελίδα δεν είναι διαθέσιμη αυτή τη στιγμή',
  [_types.ErrorPageTranslationKey.notFound]: 'Η σελίδα δε βρέθηκε',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Δεν είναι δυνατή η πρόσβαση σε αυτή τη σελίδα καθώς δεν πληροίτε όλα τα κριτήρια.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Επικοινωνήστε με την ομάδα υποστήριξης της Oriflame μέσω email:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Η διεύθυνση URL που ζητήθηκε απορρίφθηκε!'
};
